import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';

@Injectable()
export class LoginGuardService implements CanActivate {
    constructor(public router: Router) {
    }

    canActivate(): boolean {
        if (this.isAuthenticated()) {
            // console.log('Redirecting to dashboard...');
            this.router.navigate(['/dashboard']);
            return false;
        } else {
            // console.log('Redirecting to login');
            // this.router.navigate(['/login']);
        return true;
        }
    }

    isAuthenticated() {
        return (localStorage.getItem('token') || sessionStorage.getItem('token'));
    }
}
